import React, { useState, useEffect, useRef } from 'react';
import ImageCarousal from './ImageCarousal';
import VideoCarousal from './VideoCarousal';
import { useSelector } from 'react-redux';
import TextCarousal from './TextCarousal';
import DefaultCarousal from './DefaultCarousal';
import './Carousal.css';
import { useLanguage } from '../../context/Languagecontext';
import { Globals as OldGlobals } from "../../global/Globals";

const Carousal = () => {
    const { Globals ,languages, setLanguages } = useLanguage();
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isVideoPlaying, setIsVideoPlaying] = useState(false);
    const [isDotClicked, setIsDotClicked] = useState(false);
    const slideRef = useRef(null);
    const videoRef = useRef();
    const intervalRef = useRef(null); // This is to store the interval ID
    const carousalData = useSelector(state => state.carousal.carousals);
    useEffect(() => {
        if (!isVideoPlaying && carousalData?.length > 0) {
            restartCarousalInterval();
        }
        return () => clearInterval(intervalRef.current);
    }, [carousalData?.length, isVideoPlaying]);

    const handleDotClick = (index) => {
        setIsDotClicked(true);
        clearInterval(intervalRef.current);
        setCurrentIndex(index);
        if (isVideoPlaying) {
            console.log("Inside if");
            setIsVideoPlaying(false);
            videoRef.current.stopPlayback();
        }
         // Restart the interval after the dot click
         restartCarousalInterval();
    };

    const restartCarousalInterval=()=>{
        intervalRef.current = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % carousalData?.length);
            setIsDotClicked(false);
        }, OldGlobals.CAROUSAL_TIME_INTERVAL);
    }

    const handleHelpVideos = () => {
        window.open(OldGlobals.NAVPATH.VIDEOTUTORIALS, '_blank', 'noopener noreferrer');
    }

    const handleVideo = () => {
        setIsVideoPlaying(!isVideoPlaying);
    }

    return (
        <>
            <div id="carousel" className="carousel">
                <div id="slide" className="slide">
                    <div id="carousel-inner" className="carousel-inner" ref={slideRef}>
                        {carousalData?.length > 0 ? carousalData.map((item, index) => (

                            <div
                                id="carousel-item"
                                key={index}
                                className={` carousel-item ${index === currentIndex ? 'active' : ''} ${index==1 || index==2?'video-carousal':''}`}
                            >
                                {item.fileType === "jpeg" ? <ImageCarousal
                                    logoSrc={OldGlobals.IMG.CAROUSAL_LOGO}
                                    title={item.title}
                                    description={item.description}
                                    footerImageTitle={item.fileTitle ? item.fileTitle :"Channels on our portal"}
                                    footerImageSrc={item.file}
                                /> :
                                    item.fileType === "link" ? <VideoCarousal
                                        ref={videoRef}
                                        logoSrc={OldGlobals.IMG.CAROUSAL_LOGO}
                                        title={item.title}
                                        fileType={item.fileType}
                                        videoSrc={item.file}
                                        description={item.description}
                                        isVideoPlaying={isVideoPlaying}
                                        onVideoClick={handleVideo}
                                        isDotClicked={isDotClicked}
                                    /> : item.fileType === "TEXT" ? <TextCarousal
                                        logoSrc={OldGlobals.IMG.CAROUSAL_LOGO}
                                        title={item.title}
                                        description={item.description}
                                    />
                                        : ''
                                }
                            </div>
                        )) : <DefaultCarousal />}
                    </div>
                </div>
                <div className='dots-and-help-videos-container'>
                    <div className="help-videos-container">
                        <h5 onClick={handleHelpVideos}>
                            <img className="help-videos-img" src={OldGlobals.IMG.HELP_VIDEOS} alt="help videos" /><span className="help-videos">{Globals.HELP_VIDEOS}</span></h5>
                    </div>
                    <div className="carousel-dots">
                        {carousalData && carousalData.map((_, index) => (
                            <div className='dots-wrapper' key={index} onClick={() => handleDotClick(index)}>
                                <span
                                    className={`dot ${index === currentIndex ? 'active' : ''}`}
                                />
                            </div>
                        ))}
                    </div>
                </div>
                <div id="watermark" className='watermark'>
                    <h6 className="text-hider">sample</h6>
                </div>
            </div>
        </>
    );
};

export default Carousal;